<template>
  <section class="mt-3" id="chart">
    <b-row class="mt-4">
      <b-col style="">
        <apexchart type="radar" :options="options" :series="series"></apexchart>
      </b-col>
      <!--<b-col>
        <b-table striped hover :fields="tableFields" :items="tableData"></b-table>
      </b-col>-->
    </b-row>
  </section>
</template>

<script>
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import NeedUpdateMixin from "../../NeedUpdateMixin";
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

let instance = null

export default {
  name: 'RadarChart',
  props: ['filter'],

  mixins: [NeedUpdateMixin],

  created() {
    instance = this
    this.reload()
  },

  data() {
    return {
      options: {
        dataLabels: {
          enabled: false,
          formatter: (v, o) => {
            if(v)
                return f.toFixed(2)

              return v
          }
        },
        tooltip: {
          y: {
            formatter: (val) => {
              return this.$options.filters.formatDecimal(val)
            },
          },
        },
        colors: this.$store.state.colors,
        chart: {
          height: 500,
          locales: this.getChartsLocales(),
          defaultLocale: "it",
          toolbar: {
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: false,
              reset: '<img title="Reset zoom" src="/static/icons/icon-2.png" width="16">',
              customIcons: [{
                icon: '<img src="/static/icons/icon-6.png" width="16">',
                title: 'Visualizza costi',
                class: 'apex-custom-button volta-icon-euro',
                index: 0,
                click: function () {
                  instance.filter.costs = !instance.filter.costs
                  instance.reload()
                }
              }],
            }
          },
        },
      },
      series: [{
        name: 'kWh',
        data: []
      }],
      tableData: [],
      tableFields: [
        { key: 'name', sortable: true, label: 'Nome' },
        { key: 'perc', sortable: true, label: '%' },
        { key: 'value', sortable: true, label: 'kWh' }
      ]
    }
  },

  methods: {
    f(v) {
      return this.$options.filters.formatDecimal(v)
    },
    reload() {
      if (this.loading) {
        return;
      }

      if(this.filter.channels.length) {
        this.$store.commit('loading');

        this.$store.dispatch('charts/get', this.filter).then( (data) => {
          let options = _.cloneDeep(this.options)

          options.labels = data.columns.filter( (c,i) => { return i > 0 })
          this.options = options

          this.tableData = []

          let total = 0
          this.series[0].data = []
          data.columns.forEach( (c, i) => {
            if(i == 0)
              return

            let value = 0
            data.values.forEach(v => {
              value += v[i]
            })
            total += value

            const mu = data.mus[i - 1]
            this.series[0].data.push(value)
            this.series[0].name = `[${mu}]`;
          })

          data.columns.forEach( (c, i) => {
            if(i == 0)
              return

            this.tableData.push({
              name: c,
              perc: (this.series[0].data[i - 1] / total * 100).toFixed(2) + "%",
              value: this.series[0].data[i - 1].toFixed(0)
            })
          })
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        })
      }
    }
  },

  watch: {
    filter() {
      _.debounce(this.reload, 10)();
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Types/Apex/Radar.vue